var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column screen-control-planning-table__patient-cell",
    },
    [
      _c(
        "div",
        { staticClass: "screen-control-planning-table__patient-cell__wrapper" },
        [
          _c(
            "div",
            {
              staticClass:
                "screen-control-planning-table__patient-cell__patient_info",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "screen-control-planning-table__patient_cell__fullname",
                },
                [
                  _vm.patientNameVisibility
                    ? _c("kh-text", {
                        directives: [
                          {
                            name: "kh-animation",
                            rawName: "v-kh-animation",
                            value: _vm.fullNameAnimationRightToLeftProps,
                            expression: "fullNameAnimationRightToLeftProps",
                          },
                        ],
                        staticClass: "ma-0",
                        attrs: { text: _vm.fullName },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "screen-control-planning-table__patient-cell__age_gender",
                },
                [
                  _vm.getPatientDataTypeVisibility(
                    _vm.ClvrScreenControlHeadersLabelsEnum.SEX_PATIENT
                  )
                    ? _c("kh-icon", {
                        attrs: {
                          color: _vm.genderColor,
                          icon: _vm.genderIcon,
                          size: _vm.genderIconSize,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getPatientDataTypeVisibility(
                    _vm.ClvrScreenControlHeadersLabelsEnum.AGE_PATIENT
                  )
                    ? _c("kh-text", { attrs: { text: _vm.getAge } })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "screen-control-planning-table__patient-cell__others_info",
            },
            [
              _c("kh-text", {
                directives: [
                  {
                    name: "kh-animation",
                    rawName: "v-kh-animation",
                    value: _vm.othersInfoAnimationRightToLeftProps,
                    expression: "othersInfoAnimationRightToLeftProps",
                  },
                ],
                staticClass: "ma-0",
                attrs: { text: _vm.othersInfo },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }